
export const getBenchmarkDetailsStarted = (state, payload) => {
    return {
        ...state,
        fetchBenchmarkDetails: {
            ...state.fetchBenchmarkDetails,
            isProcessing: true,
            error: false,
            isDataFetched: false
        }
    };
};

export const getBenchmarkDetailsSuccess = (state, payload) => {
    return {
        ...state,
        reportSetupConfig: {
            ...state.reportSetupConfig,
            circumplex: { ...state.reportSetupConfig.circumplex, pillars: state.reportSetupConfig.circumplex && state.reportSetupConfig.circumplex.pillars ? state.reportSetupConfig.circumplex.pillars : generateCircumplexPillarData(payload.response.normScoreData) }
        },
        fetchBenchmarkDetails: {
            data: payload.response,
            isProcessing: false,
            error: false,
            isDataFetched: true
        }
    };
};

export const getBenchmarkDetailsFail = (state, payload) => {
    return {
        ...state,
        fetchBenchmarkDetails: {
            data: null,
            isProcessing: false,
            error: true,
            isDataFetched: false
        }
    };
};

const generateCircumplexPillarData = (normScoreData) => {
    if (normScoreData) {
        const colorsArray = ["#0099FF", "#E7E9E9",
            "#8CCCFF",
            "#B1B1B1"]
        let circumplexPillars = []
        normScoreData.forEach((item, index) => {
            circumplexPillars.push({
                category: item.category, categoryId: item.categoryId, subCategoriesCount: item.subCategory.length, color: colorsArray[index] ? colorsArray[index] : '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')

            })
        })
        return circumplexPillars
    }
    return []
}